import xs from "xstream"
import {div, button, table, tbody, tr, th, td, img, input, br, label, p} from "@cycle/dom"
import * as R from "ramda"

import {QR_CODE_URL} from "../../../constant"
import { getMemberPhotoUrl, getMemberType, getMemberId, getMemberByType, getMemo} from "../../common"
import { MessageInfo, MemberType, IdouKubun } from "../../../interface"
import { num2FmtStr } from "../../../utils"

const formatMessage = (msg: string) => {
	return R.intersperse(br(), R.split(/\r*\n/, msg))
}

const TYPE_DESC = [
	"お知らせ", "お願い", "重要"
]
const fmt00 = num2FmtStr("00")
const formatDate = (ldt: number) => {
	const dt = new Date(ldt);
	return `${dt.getFullYear()}年${fmt00(dt.getMonth() + 1)}月${fmt00(dt.getDate())}日 ${fmt00(dt.getHours())}:00`
}
const draw1Message = (msg: MessageInfo) => {
	return div(".message", [
		div(".sep", ["【", TYPE_DESC[msg.type], "】"]),
		div(".date", [formatDate(msg.startDate)]),
		div(".content", formatMessage(msg.message)),
	])
}
const senkouDone = (membership: any) => {
	const memo = JSON.parse(R.defaultTo("{}", R.prop("memo", membership)))
	return R.propEq("研修終了認定", "idou")(memo)
}

// const getSpecialityUpdate = (config: any, memberType: MemberType, idouKubun: IdouKubun, memberInfo: any) => {
//   const targetNendo = config.get("nendo", 0) + 1
//   const updateNendo = parseInt(R.propOr("0", "update", memberInfo) , 10)
//   const kubun = R.propOr("", "idou", memberInfo)
//   if ((targetNendo !== updateNendo) || idouKubun !== IdouKubun.Member) {
//     return false
//   }
//   if (memberType === MemberType.Senmon) {
//     const senmonUpload = config.get("senmonUpload", false)
//     if (!senmonUpload) {
//       return false
//     }
//     return kubun === "認定中" || kubun === "停止"
//   } else if (memberType === MemberType.Senkou) {
//     const senkouUpload = config.get("senkouUpload", false)
//     if (!senkouUpload) {
//       return false
//     }
//     return kubun === "研修終了認定"
//   }
//   return false 
// }
const getSpecialityUpdate = (config: any, memberType: MemberType, idouKubun: IdouKubun, memberInfo: any) => {
  const photoFlag = R.propOr(false, "photoFlag", config)
  if (memberType === MemberType.Senmon) {
    return photoFlag && R.propOr(false, "senmonUpload", config)
  } else if (memberType === MemberType.Senkou) {
    return photoFlag && R.propOr(false, "senkouUpload", config)
  }
  return photoFlag 
}

const create1ReceiptLink = (receiptDate: string) => {
  const date = receiptDate.substring(5) 
  const id = receiptDate.replace(/\//g, "")
  return div(".btn.btn-primary", { attrs: {
    style: "margin-right: 8px",
    "data-id": id,
  }}, [date])
}
const createReceiptLink = (receipts: string[]) => {
  if (R.isEmpty(receipts)) {
    return null
  }
  return div({ attrs: {
    style: "margin-top: 8px;"
  }}, [
    div({
      attrs: { style: "font-size: 9pt; font-weight: 700;" },
    }, ["【領収書ダウンロード】"]),
    div(".receiptLink", { 
      attrs: { style: "display: flex; margin: 8px" },
    },R.map(create1ReceiptLink,receipts)),
    div({
      attrs: { style: "color: red; font-size: 0.9rem;" },
    }, [
			p(".mb-1", "※ご入金日ごとのPDFデータとなります。"),
			p(".mb-1","※本会では、領収書番号で厳正に不正利用対応をしております。不正に複数ご利用された場合につきまして、本会では一切の責任を負いかねます。"),
		]),
  ])
}

export const view = (
	config$, 
	user$, 
	messages$: xs<MessageInfo[]>, 
	privateMessage$: xs<string>, 
	photoUpload$: xs<number>, 
	receipts$: xs<string[]>) =>
  xs.combine(
	config$, 
	user$, 
	messages$, 
	privateMessage$, 
	photoUpload$, 
	receipts$)
		.map(([config, user, messages, privateMessage, photoUpload, receipts]: [any, any, MessageInfo[], string, number, string[]]) => {
		const memberships = R.propOr([], "members", user)
		const memberType = getMemberType(memberships)
		const memberId = getMemberId(MemberType.Normal)(memberships)

    const isSpecial = memberType === MemberType.Senkou || memberType === MemberType.Senmon
    const specialInfo = getMemo(getMemberByType(memberType)(memberships))
		const isSenkouDone = memberType === MemberType.Senkou && senkouDone(R.find(R.propEq(memberType, "type"), memberships))
		const isStopped = memberType === MemberType.Senmon && R.propEq("停止", "idou")(specialInfo)
		const memberSpecialId = memberType === MemberType.Senkou
			? isSenkouDone
        ? "専攻医（研修終了認定）"
        : "専攻医" 
			: isStopped
        ? "停止"
        : getMemberId(memberType)(memberships)

		const isCoodinator = memberType === MemberType.Coordinator

    // const currentYear = config.get("nendo")
		// const hasUnPaid = user.get("soaId") < currentYear
		// const annualMsg = hasUnPaid ? "未納年会費があります。" : `${currentYear}年会費まで完納`
		const hasUnPaid = false
    const soaId  = R.propOr(0, "soaId", user)
		const annualMsg = soaId > 0 ? `${soaId}年会費まで完納` : "-"
		const hasMessage = R.length(messages) > 0 || privateMessage 
    const lastName = R.propOr("", "lastName", user)
    const firstName = R.propOr("", "firstName", user)
    
		let memo = {}
		try {
			memo = JSON.parse(R.propOr("{}", "memo", user))
		} catch {}
    const joinDate = R.propOr("-", "joinDate", memo)
    
    const idouKubun = R.propOr(-1, "occupation", user)
    const isSpecialityUpdate = getSpecialityUpdate(config, memberType, idouKubun, specialInfo)
		console.log(`isSpecialityUpdate: ${memberType} ${idouKubun}`)
		console.log(specialInfo)

    const receiptLink = createReceiptLink(receipts)

		return div(".panel-body.panel-primary",[
			div(".memberIdView", [
				div(".cardFrame", [
					img(".qrCode", {attrs: {src: `${QR_CODE_URL}${memberId}`}}),
					div(".message.mt8", ["このページをブックマーク(お気に入り)に登録することで簡単にご利用いただけます。"]),
					div(".mt8", [
						div(".caution", ["※注意※"]),
						div(".message", "液晶画面が暗いとバーコードを正しく読み込むことができない場合があります。"),
						div(".message", "バーコードを読み込む際に液晶画面を明るくしてください。"),
					]),
				]),
				(isSpecial && !isSenkouDone) ? div(".photoFrame", {attrs: {style: `background-image: url(${getMemberPhotoUrl(memberId)})`}}, []) : null,
				(isSpecialityUpdate) ? div(".uploadFrame.d-grid.d-md-block.text-md-center", [
          div(".caution", ["※下記のボタンより本人確認用の写真のアップロードをお願いいたします。"]),
          button(".btn.btn-block.btn-success.col-md-4.mt-2.btnUpload", { attrs: { disabled: photoUpload !== 0 } }, [
            photoUpload === 0 ? "証明写真登録" : "登録済み"
          ]),
        ]) : null,
				hasMessage ? div(".infoLabel", "**** 事務局から ****") : null,
				privateMessage ? div(".privateMessage", [
					div([`【${lastName}先生】`]),
					div(formatMessage(privateMessage)),
				]) : null,
				R.length(messages) > 0 ? div(".messages", R.map(draw1Message, messages)): null,
				table(".table.table-responsive.table-condensed.memberInfo.mt8",[
					tbody([
						tr([
							th(".bg-primary", ["会員番号"]),
							td([memberId]) ,
						]),
						tr([
							th(".bg-primary", ["お名前"]),
							td([`${lastName}　${firstName}`])
						]),
						isSpecial	
							? tr([
								th(".bg-primary", ["専門医番号"]),
								td([memberSpecialId]),
							])
							: null,
						isCoodinator
							? tr([
								th(".bg-primary", {attrs: {style: "font-size:90%;"}},["コーディネータ番号"]),
								td([memberSpecialId]),
							])
							: null,
						tr([
							th(".bg-primary", ["入会年月日"]),
							td([joinDate])
						]),
						tr([
							th(`${hasUnPaid ? ".alert .alert-danger" : ".bg-primary" }`, ["会費納入状況"]),
							td(`${hasUnPaid ? ".hasUnPaid" : "" }`, [annualMsg, receiptLink]),
						])
					])
				]),
				div(".d-grid.gap-2.d-md-flex.justify-content-md-center", [
					(isSpecial && !isSenkouDone)
            ? button(".btn.btn-block.btn-primary.btnHome.flex-grow-1",["単位照会"])
            : null,
					button(".btn.btn-block.btn-primary.btnProfile.flex-grow-1",["会員情報管理"]),
					button(".btn.btn-block.btn-info.btnMagazine.flex-grow-1",["日本生殖医学会雑誌"]),
					// div(".col-lg-2.btnPrint", [
					// 	button(".btn.btn-block.btn-success.btnPrint", {attrs: {disabled: true}}, ["QRコード印刷"]),
					// ]),
					button(".btn.btn-block.btn-danger.btnLogout2.flex-grow-1",["ログアウト"]),
				]),
			])
		])
	})
